<template>
    <div>        
        <div class="system-notice" v-show="systemNotices.length > 0">
            <div class="header-message-icon">                
                <i class="iconfont icon-xiaolaba"></i>
            </div>
            <div>
                <transition name="fade" mode="out-in">
                <p v-if="systemNoticeSwitch1 != null" key="systemNoticeSwitch1">{{systemNoticeSwitch1.contentCn}}</p>
                <p v-if="systemNoticeSwitch2 != null" key="systemNoticeSwitch2">{{systemNoticeSwitch2.contentCn}}</p>
                </transition>
            </div>
        </div>
        <div ref="wrapper" class="scroll-content" :style="{height: contentH + 'px'}">
            <mt-loadmore :auto-fill="false" :bottom-method="handleLoadMore" :bottom-all-loaded="allLoaded" ref="loadmore">
                <div>
                    <div @click="handleViewClick(msg)" class="field-block" v-for="(msg, index) in messages" :key="index">
                        {{msg.msgContent | removeHtmlTag}} <label v-show="msg.meetingId">点击查看</label>
                    </div>
                </div>
            </mt-loadmore>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters  } from 'vuex';
import listApi from '@/api/messages/list';

export default {
  data() {
    return {
        messageBoxIcon: 'icon-xiaoxi',      
        messages: [
        ],
        systemNoticeSwitch1: null,
        systemNoticeSwitch2: null,
        currentSystemNoticeIndex: 0,
        readCount: 0,
        unApproveCount: 0,   
        pageData: {
            pageNo: 0,
            pageSize: 10,
            total: 0
        },
        allLoaded: true,
        contentH: 0,
    };
  },
  computed: {
    ...mapGetters(['userInfo','systemNotices','hasUnapproveCount'])
  },
  methods: {
    ...mapActions(['initSystemNotices', 'hideSystemNotice', 'initUnapproveCount']),
    handleUserClick(item) {
      this.$router.push({
            name: 'user-personal-center'
          })
    },
    showSystemNotice() {
      setTimeout(()=>{
        if(this.systemNotices.length > 1){
          //systemNotices的长度变短，重置currentSystemNoticeIndex
          if(this.currentSystemNoticeIndex + 1 > this.systemNotices.length) {
            this.currentSystemNoticeIndex = -1;
          }
          this.currentSystemNoticeIndex = (this.currentSystemNoticeIndex + 1) % this.systemNotices.length;
          if(!this.systemNoticeSwitch1) {
            this.systemNoticeSwitch1 = this.systemNotices[this.currentSystemNoticeIndex];
            this.systemNoticeSwitch2 = null;
          }
          else{
            this.systemNoticeSwitch1 = null;
            this.systemNoticeSwitch2 = this.systemNotices[this.currentSystemNoticeIndex];
          }
          this.showSystemNotice();
        }
        else{
          //剩下一个，使用 systemNoticeSwitch1 显示
          this.currentSystemNoticeIndex = 0;
          this.systemNoticeSwitch1 = this.systemNotices[this.currentSystemNoticeIndex];
          this.systemNoticeSwitch2 = null;
          this.showSystemNotice();
        }
      },5000)
    },
    handleSearch(pageNo) {
        if(pageNo == 1) {
            this.messages = [];
        }
        listApi.list({
                pageNo : pageNo || this.pageData.pageNo,
                pageSize : this.pageData.pageSize
            })
            .then(res => {
                res.records.forEach(el => {
                    this.messages.push(el);
                })

                this.pageData.pageNo = res.current;
                this.pageData.total = res.total;

                this.allLoaded = this.pageData.pageNo*this.pageData.pageSize >= this.pageData.total;
                if(this.$refs.loadmore) {
                    this.$refs.loadmore.onBottomLoaded();
                }

                if(pageNo == 1) {
                    this.$nextTick(() => {
                        this.$refs.wrapper.scrollTo(0,0);
                    })
                }
            })     
    }, 
    handleLoadMore() {
        this.handleSearch(this.pageData.pageNo+1,true)
    },
    handleViewClick(data) {
        if(!data.meetingId) {
            return;
        }
        
      if(data.readFlag == '0'){
        listApi.readMessageByAnntId({anntIds:[data.anntId]});
      }

      if(data.myMeeting == '1') {
        this.$router.push({
          name: 'meetingplan-application-view',
          params: {'id':data.meetingId}
        }); 
      }
      else {
        this.$router.push({
          name: 'meetingplan-task-view',
          params: {'id':data.meetingId}
        }); 
      }
    },
    resizeLayout() {
        this.contentH = document.documentElement.clientHeight - 
                 this.$refs.wrapper.getBoundingClientRect().top    
                 - (document.getElementsByClassName('mint-tabbar')[0].clientHeight);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeLayout, true)
  },
  mounted() {
    this.contentH = document.documentElement.clientHeight - 
                 this.$refs.wrapper.getBoundingClientRect().top
                 - (document.getElementsByClassName('mint-tabbar')[0].clientHeight);

    this.initSystemNotices()
      .then(() => {
        this.currentSystemNoticeIndex = 0;
          if(this.systemNotices.length > 0){
            this.systemNoticeSwitch1 = this.systemNotices[0];
            this.showSystemNotice();
            this.handleSearch(1)
          }          
      })

    window.addEventListener('resize', this.resizeLayout, true);
  },
  created() {}
};
</script>

<style lang="less" scoped>
.system-notice {
    height: 40px;
    background-color: #ffffff;
    display: flex;
    position: fixed;
    width: 375px;
    top: 0;

    .header-message-icon {
      padding-left: 18px;
      padding-right: 10px;
      line-height: 40px;

      i {
        font-size: 12px;
        color: #F7B500;
      }
    }

    p {
        margin: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 300px;
        white-space: nowrap;
        font-size: 12px;
        color: @subSubFontColor;
        height: 40px;
        line-height: 40px;
    }
}

.field-block {
    font-size: 0.373333rem;
    color: #333333;
    margin: 10px 15px 0 15px;
    padding: 10px 15px 10px 15px;
    background-color: #fff;
    border-radius: 10px;

    label {
        font-size: 12px;
        font-weight: 400;
        color: #0066cc;
        margin-left: 5px;
    }
}

    .scroll-content {
        margin-top: 40px;
        padding-bottom: 73px;
        overflow-y: auto;
        z-index: 1;
        // height: 500px;
    }

.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-15px);
}

.fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// index.vue?64fefd15